import React from 'react';
import './Button.css';

export interface IButtonParams {
    text: string;
    width?: string;
    backgroundColor?: string;
    borderColor?: string;
    borderWidth?: string;
    borderStyle?: string;
    color?: string;
    onClick: () => void;
    disable?: boolean;
    testId?: string;
    fontSize?: string;
    height?: string;
    borderRadius?: string;
    fontWeight?: string;
}

const Button: React.FC<IButtonParams> = ({
    text,
    testId,
    width,
    backgroundColor,
    color,
    borderColor,
    borderWidth,
    borderStyle,
    fontSize,
    onClick,
    disable = false,
    height,
    fontWeight,
    borderRadius,
}) => {
    const defaultBackgroundColor = backgroundColor ? backgroundColor : 'var(--primary-gradient)';
    const defaultColor = color ? color : 'white';
    const defaultBorderRadius = borderRadius ? borderRadius : '24px';
    const defaultHeight = height ? height : '48px';
    const defaultBorderColor = borderColor ? borderColor : 'transparent';
    const defaultBorderWidth = borderWidth ? borderWidth : '1px';
    const defaultBorderStyle = borderStyle ? borderStyle : 'solid';
    return (
        <>
            <button
                type='button'
                className='btn'
                onClick={() => onClick()}
                data-testid={testId}
                id={text}
                style={{
                    width: width,
                    background: defaultBackgroundColor,
                    color: defaultColor,
                    borderRadius: defaultBorderRadius,
                    borderColor: defaultBorderColor,
                    borderWidth: defaultBorderWidth,
                    borderStyle: defaultBorderStyle,
                    whiteSpace: 'nowrap',
                    zIndex: '1',
                    fontSize: fontSize ? fontSize : '15px',
                    minWidth: 'fit-content',
                    height: defaultHeight,
                    padding: '10px 30px',
                    fontWeight: fontWeight,
                    border: disable? '1px var(--color-primary-translucent)': 'none',

                }}
                disabled={disable}
            >
                {text}
            </button>
        </>
    );
};
export default Button;